// Vuex connections module mutations types

export const FILL_LIST = 'FILL_LIST';
export const FILL_PROJECT = 'FILL_PROJECT';
export const UPDATE_LIST_BY_CALLBACK_STEP = 'UPDATE_LIST_BY_CALLBACK_STEP';
